export interface ContentItem {
  id: string;
  title: string;
  type: 'movie' | 'tv';
  year: number;
  genres: string[];
  region: string;
  director: string;
  cast: string[];
  rating: number;
  duration: string;
  poster: string;
  backdrop: string;
  views: number;
  summary: string;
  synopsis: string;
  tags: string[];
  featured?: boolean;
}

export const catalog: ContentItem[] = [
  {
    id: 'm1',
    title: '星际远征',
    type: 'movie',
    year: 2025,
    genres: ['科幻', '冒险', '剧情'],
    region: '中国大陆',
    director: '陈星河',
    cast: ['刘奕君', '张若尘', '许清嘉'],
    rating: 8.7,
    duration: '142分钟',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20art%20of%20a%20deep%20space%20voyage%20with%20astronauts%20and%20a%20glowing%20nebula%2C%20dark%20navy%20blue%20tones%20with%20warm%20amber%20light%2C%20dramatic%20atmospheric%20vertical%20composition&width=480&height=720&seq=kh-poster-m1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20space%20exploration%20ship%20drifting%20past%20a%20vast%20purple%20and%20blue%20nebula%2C%20epic%20sci-fi%20atmosphere%20with%20deep%20shadows%20and%20volumetric%20light%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m1&orientation=landscape',
    views: 982000,
    summary: '一支人类远征舰队驶向未知星系，在深空信号中发现了远超想象的文明遗迹。',
    synopsis: '公元2107年，地球资源濒临枯竭。由指挥官林澈率领的“祝融号”远征舰队踏上寻找新家园的旅程。在穿越柯伊伯带后的第三年，舰队接收到一段穿越数万年时空的重复信号。为了解开信号之谜，船员们深入一片从未被记录的星域，却在一颗冰封行星的深层发现了不属于人类的海底遗迹。随着调查深入，队长林澈必须在自己对家园的执念与全舰两千三百人的生死之间做出抉择。影片以冷峻的硬科幻视觉与细腻的人物刻画，探讨了孤独、信任与文明存续的永恒命题。',
    tags: ['硬科幻', '太空', '人类命运', '视觉奇观'],
    featured: true,
  },
  {
    id: 'm2',
    title: '长安夜行',
    type: 'movie',
    year: 2024,
    genres: ['古装', '武侠', '悬疑'],
    region: '中国大陆',
    director: '顾长风',
    cast: ['江疏影', '王砚辉', '李思宁'],
    rating: 8.4,
    duration: '136分钟',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20wuxia%20movie%20poster%20with%20a%20lantern%20lit%20night%20street%20of%20Chang%20an%20and%20a%20silhouetted%20swordsman%2C%20gold%20and%20deep%20blue%20tones%2C%20dramatic%20vertical%20painting&width=480&height=720&seq=kh-poster-m2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20ancient%20Chinese%20city%20ramparts%20at%20night%20lit%20by%20hundreds%20of%20red%20lanterns%2C%20misty%20atmosphere%20and%20deep%20blue%20sky%2C%20epic%20wuxia%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m2&orientation=landscape',
    views: 861000,
    summary: '盛唐长安一夜之间连发奇案，落魄捕快与神秘女子联手追凶，揭开埋藏十年的旧怨。',
    synopsis: '天宝年间，长安城。上元灯节前夜，平康坊接连发生命案，死者身上均留有半枚铜钱。被贬的三班捕快裴准临危受命，与身份成谜的琵琶女苏夜娘结成临时同盟。两人循着铜钱的线索，从教坊司查到东市胡商，再一路追至城外废弃的烽燧。线索最终指向十年前一场被掩盖的军械贪腐案，而案件的余波至今仍在侵蚀这座帝国的心脏。影片以考究的美术与凌厉的动作设计，重现了一个瑰丽又危险的盛唐之夜。',
    tags: ['盛唐', '探案', '江湖', '权谋'],
    featured: true,
  },
  {
    id: 'm3',
    title: '追风者',
    type: 'movie',
    year: 2025,
    genres: ['动作', '犯罪', '惊悚'],
    region: '中国香港',
    director: '林卓贤',
    cast: ['谢天华', '庄晓曼', '陈子谦'],
    rating: 7.9,
    duration: '118分钟',
    poster: 'https://readdy.ai/api/search-image?query=action%20movie%20poster%20of%20a%20motorcyclist%20speeding%20through%20a%20neon%20lit%20rainy%20city%20street%20with%20dynamic%20motion%20blur%2C%20dark%20blue%20and%20orange%20contrast%2C%20vertical%20composition&width=480&height=720&seq=kh-poster-m3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20night%20shot%20of%20a%20rider%20on%20a%20superbike%20weaving%20through%20dense%20Hong%20Kong%20traffic%20with%20wet%20reflective%20roads%20and%20neon%20signs%2C%20high%20speed%20energy%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m3&orientation=landscape',
    views: 737000,
    summary: '一名卧底车手潜入地下飙车集团，在速度与谎言之间逐渐分不清敌我。',
    synopsis: '重案组警员高朗以顶级车手身份潜入活跃于港岛的地下飙车集团“风眼”。他很快赢得首领“阿鬼”的信任，却在一次次生死竞速中与对手们生出兄弟般的情谊。当警方收网在即，一条被刻意泄露的情报让整个行动陷入混乱。高朗必须在身份暴露前找出真正的内鬼，而真相远比他想象的更接近自己。影片以大量实拍赛车场面与紧凑的叙事节奏，呈现了一场关于忠诚与背叛的城市追逐。',
    tags: ['赛车', '卧底', '港式动作', '飙车'],
  },
  {
    id: 'm4',
    title: '深海回响',
    type: 'movie',
    year: 2024,
    genres: ['悬疑', '惊悚', '剧情'],
    region: '英国',
    director: '艾琳·沃克',
    cast: ['汤姆·里德', '艾米莉·肖', '丹尼尔·凯恩'],
    rating: 8.1,
    duration: '125分钟',
    poster: 'https://readdy.ai/api/search-image?query=mysterious%20deep%20sea%20thriller%20movie%20poster%20of%20a%20dark%20ocean%20abyss%20with%20a%20faint%20light%20beam%20and%20eerie%20atmosphere%2C%20deep%20teal%20and%20black%20tones%2C%20vertical&width=480&height=720&seq=kh-poster-m4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20underwater%20wide%20scene%20of%20a%20tiny%20submersible%20descending%20into%20a%20pitch%20black%20trench%20with%20faint%20blue%20bioluminescence%2C%20claustrophobic%20thriller%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m4&orientation=landscape',
    views: 604000,
    summary: '一支深海科考队在马里亚纳海沟录到一段来源不明的声音，从此再无人能安然入睡。',
    synopsis: '海洋声学研究员艾米莉加入一支国际科考队，前往太平洋深处布设新型水听器阵列。下潜至八千米时，设备录下一段规律得近乎“语言”的低频声波。随着队内成员接连出现幻觉与失眠，队长汤姆决定提前返航，却发现潜航器已经被某种力量牵引向更深处。科学与未知的边界在此崩塌，艾米莉不得不面对一个令人战栗的推论：人类或许从来都不是这片深海的访客。',
    tags: ['深海', '心理惊悚', '未知恐惧', '科学伦理'],
  },
  {
    id: 'm5',
    title: '山海秘境',
    type: 'movie',
    year: 2025,
    genres: ['奇幻', '冒险', '古装'],
    region: '中国大陆',
    director: '徐墨白',
    cast: ['苏晓彤', '韩东君', '柳映白'],
    rating: 8.0,
    duration: '148分钟',
    poster: 'https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%20of%20ancient%20mythical%20mountains%20in%20mist%20with%20a%20glowing%20mythical%20creature%2C%20teal%20and%20amber%20tones%2C%20mystical%20vertical%20artwork&width=480&height=720&seq=kh-poster-m5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20fantasy%20landscape%20of%20floating%20mountains%20above%20a%20sea%20of%20clouds%20with%20a%20giant%20glowing%20bird%20flying%20past%2C%20mythical%20Chinese%20art%20style%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m5&orientation=landscape',
    views: 690000,
    summary: '少年循着祖父留下的残卷闯入山海秘境，只为寻回一味能救人的上古灵药。',
    synopsis: '制药世家出身的少女阿萦为救治身中奇毒的母亲，依照祖父遗留的《山海残卷》踏上寻找“青丘之息”的旅途。她与落魄的机关师少年白砚结伴，穿越会移动的密林、栖息着异兽的深渊与终年不散的云海。传说中守护灵药的毕方神鸟并非恶兽，而是等待了千年的契约者。当阿萦发现祖父的失踪与秘境核心的秘密紧紧相连时，她必须在取药与守诺之间做出选择。',
    tags: ['山海经', '东方奇幻', '冒险', '亲情'],
    featured: true,
  },
  {
    id: 'm6',
    title: '时光信箱',
    type: 'movie',
    year: 2023,
    genres: ['爱情', '剧情', '奇幻'],
    region: '韩国',
    director: '朴敏贞',
    cast: ['李在勋', '金多美', '崔敏静'],
    rating: 7.7,
    duration: '112分钟',
    poster: 'https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20a%20vintage%20mailbox%20in%20a%20warm%20sunset%20park%20with%20falling%20leaves%2C%20soft%20golden%20tones%20and%20nostalgic%20mood%2C%20vertical&width=480&height=720&seq=kh-poster-m6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20a%20quiet%20town%20post%20office%20at%20dusk%20with%20warm%20amber%20sunlight%20and%20falling%20autumn%20leaves%2C%20gentle%20romantic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m6&orientation=landscape',
    views: 528000,
    summary: '一个能寄信给过去的旧信箱，让两个相隔十年的陌生人开始了一场漫长的对话。',
    synopsis: '失业的插画师秀雅在老城区整理祖母遗物时，发现了一只刻着奇怪铭文的铁皮信箱。她随手投进一封写给自己的信，第二天却在箱底收到了一封署名“1998年·俊昊”的回信。两个相隔二十年的陌生人就此展开了一段跨越时间的通信：他告诉她那年夏天的雨，她告诉他未来城市的模样。当他们终于试图见面时，却发现自己正一步步走向那个注定的时间悖论。',
    tags: ['穿越时空', '书信', '治愈', '纯爱'],
  },
  {
    id: 'm7',
    title: '城市之光',
    type: 'movie',
    year: 2024,
    genres: ['剧情', '犯罪'],
    region: '中国大陆',
    director: '贾行舟',
    cast: ['段奕宏', '周依然', '黄尧'],
    rating: 8.3,
    duration: '131分钟',
    poster: 'https://readdy.ai/api/search-image?query=urban%20drama%20movie%20poster%20of%20a%20lonely%20figure%20walking%20in%20a%20rain%20soaked%20city%20at%20night%20with%20warm%20street%20lights%2C%20melancholic%20cinematic%20tonality%2C%20vertical&width=480&height=720&seq=kh-poster-m7&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20view%20of%20a%20vast%20modern%20city%20with%20glowing%20windows%20and%20a%20lone%20figure%20on%20an%20empty%20bridge%2C%20moody%20blue%20and%20amber%20light%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m7&orientation=landscape',
    views: 612000,
    summary: '一名夜间巡逻的老警察，在退休前的最后一个月里遇见了一个偷东西的少年。',
    synopsis: '在市中心派出所工作了三十年的老周即将退休。最后一个月，他负责夜间巡逻。一个雨夜，他抓到了在便利店偷面包的少年小凯。按规定处理完笔录后，老周却发现这孩子每晚都会出现在同一条街上。他跟着少年走进这座城市被遗忘的角落：天桥下的流浪者、深夜开张的面馆、还有那栋即将被拆除的老居民楼。两个相隔四十岁的人在夜色里彼此靠近，也照见了这座城市不愿被看见的光。',
    tags: ['现实主义', '城市', '人性', '温情'],
  },
  {
    id: 'm8',
    title: '极速人生',
    type: 'movie',
    year: 2025,
    genres: ['动作', '运动', '剧情'],
    region: '美国',
    director: '马克·道森',
    cast: ['克里斯·贝尔', '露娜·海耶斯', '德里克·王'],
    rating: 7.6,
    duration: '129分钟',
    poster: 'https://readdy.ai/api/search-image?query=racing%20movie%20poster%20of%20a%20formula%20race%20car%20drifting%20on%20a%20wet%20track%20with%20sparks%20and%20dramatic%20speed%2C%20orange%20and%20dark%20tones%2C%20vertical%20composition&width=480&height=720&seq=kh-poster-m8&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20race%20car%20cornering%20hard%20on%20a%20floodlit%20circuit%20at%20night%20with%20spray%20and%20motion%20blur%2C%20high%20octane%20energy%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m8&orientation=landscape',
    views: 705000,
    summary: '被禁赛的天才车手重返赛道，只为完成父亲未竟的那一圈。',
    synopsis: '曾经的赛道新星凯尔因一次事故被终身禁赛，只能在小镇修理厂里虚度光阴。五年后，一支濒临解散的独立车队找到了他——他们手里有父亲当年未完成的设计图纸。为了重返赛场，凯尔必须通过层层资格赛，还要直面那场事故留下的心理阴影与昔日队友的质问。当最后一圈的弯道出现在眼前，他要赢的早已不只是比赛。',
    tags: ['赛车', '父子', '热血', '逆袭'],
    featured: true,
  },
  {
    id: 'm9',
    title: '幽灵列车',
    type: 'movie',
    year: 2023,
    genres: ['恐怖', '悬疑'],
    region: '日本',
    director: '佐藤凉',
    cast: ['松本惠', '高桥优', '小林健吾'],
    rating: 7.2,
    duration: '104分钟',
    poster: 'https://readdy.ai/api/search-image?query=horror%20movie%20poster%20of%20an%20abandoned%20dark%20subway%20train%20in%20fog%20with%20a%20faint%20red%20light%2C%20chilling%20atmosphere%2C%20desaturated%20vertical%20composition&width=480&height=720&seq=kh-poster-m9&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20an%20empty%20dim%20subway%20platform%20at%20night%20with%20one%20approaching%20train%20headlight%20in%20thick%20fog%2C%20eerie%20horror%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m9&orientation=landscape',
    views: 431000,
    summary: '末班车之后，还停着一列不在时刻表上的地铁。',
    synopsis: '加班到深夜的上班族真木错过了末班车，却在站台尽头看见一列亮着昏黄灯光的列车缓缓进站。车门打开，车厢里的乘客都低着头一动不动。她鬼使神差地上了车，从此再也没能下站。同一时间，车站管理员开始翻查监控，试图找出近三个月里在这条线路上失踪的九名乘客之间，究竟有着怎样的共同点。真相藏在这趟列车永远不报站的终点站。',
    tags: ['都市传说', '密室', '氛围恐怖', '悬疑'],
  },
  {
    id: 'm10',
    title: '江湖再见',
    type: 'movie',
    year: 2024,
    genres: ['喜剧', '古装', '武侠'],
    region: '中国大陆',
    director: '王铁柱',
    cast: ['马小东', '吴倩', '范明远'],
    rating: 7.3,
    duration: '108分钟',
    poster: 'https://readdy.ai/api/search-image?query=comedy%20movie%20poster%20of%20a%20colorful%20lively%20ancient%20Chinese%20town%20street%20scene%20with%20playful%20characters%2C%20warm%20bright%20tones%2C%20cheerful%20vertical%20illustration&width=480&height=720&seq=kh-poster-m10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20a%20bustling%20ancient%20Chinese%20market%20street%20in%20daytime%20with%20banners%20and%20colorful%20stalls%2C%20light%20hearted%20comedy%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-m10&orientation=landscape',
    views: 476000,
    summary: '过气剑客想金盆洗手，却发现自己唯一值钱的家当是江湖上人人惦记的“退隐证书”。',
    synopsis: '曾经名震一时的剑客“快剑”老宋决意退出江湖，在江南小镇盘了家包子铺。谁知他随手挂在墙上的“退隐证书”竟是当年武林盟主签发的信物，谁拿到就能号令三大门派。一时间，各路“高手”轮番登门，有的要买、有的要抢、还有的纯粹来蹭包子。老宋只能一边揉面一边应付这场荒唐的围堵，最后发现挂错了人的证书，才是整件事最大的笑点。',
    tags: ['爆笑', '反武侠', '小人物', '合家欢'],
  },
  {
    id: 't1',
    title: '风起洛阳',
    type: 'tv',
    year: 2024,
    genres: ['古装', '历史', '悬疑'],
    region: '中国大陆',
    director: '高翎',
    cast: ['王一川', '宋佳宁', '沈澈'],
    rating: 8.6,
    duration: '共36集 · 每集45分钟',
    poster: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20historical%20drama%20series%20poster%20of%20a%20grand%20palace%20at%20dusk%20under%20dramatic%20clouds%2C%20deep%20blue%20and%20gold%20tones%2C%20epic%20vertical%20artwork&width=480&height=720&seq=kh-poster-t1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20a%20vast%20ancient%20Chinese%20imperial%20palace%20complex%20at%20golden%20dusk%20with%20ceremonial%20guards%2C%20grand%20historical%20atmosphere%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-t1&orientation=landscape',
    views: 1240000,
    summary: '神都洛阳暗流涌动，三位身份迥异的年轻人被卷入一场关乎国运的迷局。',
    synopsis: '武周年间，神都洛阳。不良人出身的阿鹤、出身名门的裴照与身份成谜的药师陆青，因一桩看似寻常的投毒案相遇。随着调查推进，三人发现事件背后牵涉到军粮调拨、漕运账本与一支从未在兵部登记的神秘卫队。他们要面对的不仅是层层设防的权贵，还有各自家族背负的秘密。当真相逐渐浮出水面，洛阳城的每一块砖瓦都成了局中棋子。',
    tags: ['古装探案', '群像', '权谋', '制作精良'],
  },
  {
    id: 't2',
    title: '都市浮生',
    type: 'tv',
    year: 2025,
    genres: ['都市', '剧情', '爱情'],
    region: '中国大陆',
    director: '李牧',
    cast: ['赵山河', '陈数', '林晚'],
    rating: 8.0,
    duration: '共40集 · 每集42分钟',
    poster: 'https://readdy.ai/api/search-image?query=urban%20drama%20series%20poster%20of%20a%20modern%20city%20skyline%20at%20night%20reflected%20on%20wet%20streets%2C%20cool%20blue%20tones%20with%20warm%20window%20lights%2C%20cinematic%20vertical&width=480&height=720&seq=kh-poster-t2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20aerial%20night%20view%20of%20a%20sprawling%20modern%20metropolis%20with%20glowing%20office%20towers%20and%20car%20light%20trails%2C%20urban%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-t2&orientation=landscape',
    views: 918000,
    summary: '同一栋写字楼里，四个普通人在各自的困境中努力把日子过成想要的样子。',
    synopsis: '故事发生在市中心一栋写字楼：离婚后独自带娃的项目经理苏棠、刚被裁员的程序员老曹、白天做保洁晚上学画的中年阿姨周兰、以及刚回国创业的富二代方知远。四个人因为一部故障的电梯而结识，从此在各自的忙碌与狼狈中互相搭把手。剧集以单元式的结构，呈现都市人在职场、家庭与自我之间的拉扯，也记录下那些微小却真实的温柔。',
    tags: ['都市群像', '现实', '治愈', '职场'],
  },
  {
    id: 't3',
    title: '谜案追踪',
    type: 'tv',
    year: 2024,
    genres: ['犯罪', '悬疑', '惊悚'],
    region: '韩国',
    director: '郑镇宇',
    cast: ['朴志勋', '韩素拉', '崔东旭'],
    rating: 8.5,
    duration: '共16集 · 每集60分钟',
    poster: 'https://readdy.ai/api/search-image?query=crime%20mystery%20series%20poster%20of%20a%20detective%20silhouette%20with%20a%20magnifying%20glass%20over%20a%20dark%20rainy%20alley%2C%20moody%20desaturated%20tones%2C%20vertical&width=480&height=720&seq=kh-poster-t3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20scene%20of%20a%20narrow%20rain%20slicked%20alley%20lit%20by%20a%20single%20flickering%20lamp%20with%20police%20tape%2C%20tense%20crime%20drama%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-t3&orientation=landscape',
    views: 803000,
    summary: '一桩尘封二十年的悬案重新翻开，退休法医与年轻女警组成最不被看好的搭档。',
    synopsis: '二十年前的“月尾洞案”从未真正结案。如今，一起手法高度相似的新案让当年负责的老法医姜道贤重新回到警局。与他搭档的是刚从首尔调来的女警车秀妍——一个信奉数据与证据的年轻人。两人一个凭直觉与经验，一个靠逻辑与痕迹，在互不信任中逼近真相。随着调查深入，他们发现当年的卷宗被人系统性篡改，而幕后之人可能一直就在他们身边。',
    tags: ['犯罪推理', '双人搭档', '高能反转', '犯罪档案'],
  },
  {
    id: 't4',
    title: '星海守望',
    type: 'tv',
    year: 2025,
    genres: ['科幻', '冒险', '剧情'],
    region: '美国',
    director: '德里克·莫尔',
    cast: ['艾登·克罗斯', '娜塔莉·格林', '山姆·维加'],
    rating: 8.2,
    duration: '共10集 · 每集55分钟',
    poster: 'https://readdy.ai/api/search-image?query=sci-fi%20series%20poster%20of%20an%20astronaut%20gazing%20at%20a%20vast%20star%20field%20and%20a%20distant%20planet%2C%20navy%20and%20teal%20tones%2C%20cinematic%20vertical&width=480&height=720&seq=kh-poster-t4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20from%20a%20space%20station%20window%20overlooking%20a%20blue%20ringed%20planet%20and%20countless%20stars%2C%20serene%20sci-fi%20atmosphere%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-t4&orientation=landscape',
    views: 764000,
    summary: '在地球轨道上独自值守的最后一位宇航员，开始收到来自深空的回应。',
    synopsis: '近未来，地球生态濒临崩溃，人类撤往火星的转移计划已进入最后阶段，只留下“守望者”号空间站维持轨道监测。宇航员伊莱独自值守，任务是为期九百天的例行观测。第两百一十天，他收到了响应自己日常通讯的信号——那不可能来自地球，也不可能来自任何已知的探测器。随着信号越来越频繁，伊莱开始怀疑：他究竟是这座空间站唯一的乘员，还是被留在这里的诱饵。',
    tags: ['太空歌剧', '孤独', '悬念', '视觉震撼'],
    featured: true,
  },
  {
    id: 't5',
    title: '家有暖阳',
    type: 'tv',
    year: 2023,
    genres: ['家庭', '都市', '剧情'],
    region: '中国大陆',
    director: '周慧兰',
    cast: ['齐怀民', '何雅君', '孙宁'],
    rating: 7.8,
    duration: '共32集 · 每集45分钟',
    poster: 'https://readdy.ai/api/search-image?query=warm%20family%20series%20poster%20of%20a%20cozy%20living%20room%20with%20soft%20sunlight%20through%20the%20window%20and%20green%20plants%2C%20warm%20amber%20tones%2C%20vertical&width=480&height=720&seq=kh-poster-t5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20warm%20scene%20of%20a%20comfortable%20family%20dining%20table%20set%20for%20a%20meal%20with%20golden%20afternoon%20light%20streaming%20in%2C%20homey%20atmosphere%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-t5&orientation=landscape',
    views: 542000,
    summary: '三代同堂的老宅里，一顿晚饭能吵三回，也能笑三回。',
    synopsis: '退休教师老齐和老伴住在城郊的老宅里，儿子一家搬回来同住后，这个家彻底热闹起来：孙子要备战高考、儿媳忙着创业、儿子夹在中间左右为难，还有时不时上门的亲戚邻里。剧集围绕一日三餐与四季更迭，把中国家庭里那些说不出口的关心、拌了嘴的惦记，都织进一个个琐碎又温暖的日常。',
    tags: ['家庭剧', '年代感', '烟火气', '治愈'],
  },
  {
    id: 't6',
    title: '青春纪事',
    type: 'tv',
    year: 2024,
    genres: ['青春', '校园', '爱情'],
    region: '中国大陆',
    director: '姜澈',
    cast: ['林一舟', '苏眠', '程野'],
    rating: 7.5,
    duration: '共24集 · 每集40分钟',
    poster: 'https://readdy.ai/api/search-image?query=youth%20campus%20series%20poster%20of%20students%20cycling%20on%20a%20tree%20lined%20road%20in%20golden%20afternoon%20light%2C%20fresh%20bright%20nostalgic%20tones%2C%20vertical&width=480&height=720&seq=kh-poster-t6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20a%20school%20campus%20in%20late%20afternoon%20with%20students%20walking%20under%20golden%20poplar%20trees%2C%20sunny%20nostalgic%20mood%2C%20no%20text&width=1600&height=900&seq=kh-backdrop-t6&orientation=landscape',
    views: 611000,
    summary: '高二分班那年夏天，六个少年在考试、梦想和暗恋里跌跌撞撞地长大。',
    synopsis: '故事从一次普通的分班考试开始。林一舟、苏眠和他们的五个同学被分到同一个班级，也分到了同一段兵荒马乱的高中时光。有人在竞赛与保送之间纠结，有人偷偷把志愿表改了三次，有人把喜欢藏在借出去的笔记里。剧集用单元式的季节更替，记录下青春里那些难忘的细节：晚自习的灯光、操场上的呐喊，和毕业那天谁也没说出口的那句话。',
    tags: ['校园', '群像', '成长', '怀旧'],
  },
];

export const genreOptions = ['全部', '科幻', '动作', '悬疑', '剧情', '爱情', '喜剧', '奇幻', '古装', '犯罪', '家庭', '青春', '都市', '惊悚', '冒险', '历史', '校园', '武侠', '运动', '恐怖'];
export const regionOptions = ['全部', '中国大陆', '中国香港', '美国', '韩国', '日本', '英国'];
export const yearOptions = ['全部', '2025', '2024', '2023'];